var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItalic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Italic_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 24052",
    transform: "translate(526 261)",
    d: "M0 0h24v24H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-526 -261)",
    clipPath: "url(#Italic_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24051",
    width: 20,
    height: 4,
    rx: 2,
    transform: "rotate(-70 467.514 -239.53)"
  }))));
}
export default SvgItalic;